<!--
모달 컨텍스트 헤더 (공용 app-buy-order-ctx — TASK-161 사이클 16 #27)
------------------------------------
 - 사용자 (2026-10-10): 「해외오더번호 · 트래킹 · 대금상환금액 등은 지금보다 잘 보이게」 — 구 모달 제목 아래 회색 텍스트 3줄 대체
 - 사용처 = 대금상환 창고지급 · 정정 · 정산확정 · 창고지급취소 · 비고 모달 (cod-payment/*-popup.vue) · 구매정보저장 (오더번호 텍스트 모드) · 구매정보 수정 레이어
 - 모양 = 모달 제목 아래 연회색 블록 (#f3f5f9 · 6px 모서리 · 패딩 10 14) — 키-값 (라벨 회색 1rem)
     1줄 해외오더번호 = 1.2rem 모노 굵게 #111 + 복사 (copy 컴포넌트) [+ slot note — 보조 문구]
     2줄 트래킹 = 1.4rem 모노 굵게 #111 + 번호마다 복사 (TASK-172 절 D — 금액과 동급, 구 .htrk 칩 1rem · 복사 없음 대체 · 7 모달 공통 결정 ⑨)
                  — 빈 배열 = 회색 「없음」 (결정 ⑬) / prop 미지정 (null) = 줄 숨김
 - 머리 아래 구분선 1px (TASK-172 결정 v2-④ — 공용 부품이라 7 모달 공통, 블록 아래 여백 가운데 ::after)
     3줄~ items = 키-값 2쌍 / 줄 (쌍 = 폭 절반, 큰 금액이 절반에 안 들어가면 그 쌍만 한 줄 — 600px 모달에서도 금액 중간 줄바꿈 없음)
              big = 1.4rem 700 #1f2d4d 등폭 숫자 (카드 금액 문법) · red = #c62828 · mono = 모노 글꼴
 - E2E 셀렉터 보존용: code-class (오더번호 값 class — cdp-memo-ctx__code · br-store-code-text) · item.cls (값 class — cdp-confirm-req 등)
                      · 루트 class = 호출부 class 속성 (cdp-memo-ctx · br-store-code · bo-edit-order)
 - 글자 1rem 이상
-->
<template>
    <dl class="bo-ctx">
        <div class="bo-ctx__row bo-ctx__row--full">
            <dt class="bo-ctx__k">해외오더번호</dt>
            <dd class="bo-ctx__v bo-ctx__codeline">
                <b class="bo-ctx__code" :class="codeClass">{{ hasCode ? code : '—' }}</b>
                <copy v-if="copyable && hasCode" tooltip="오더번호 복사" :copy-text="code"></copy>
                <slot name="note"></slot>
            </dd>
        </div>

        <div v-if="trackings !== null" class="bo-ctx__row bo-ctx__row--full">
            <dt class="bo-ctx__k">트래킹</dt>
            <dd class="bo-ctx__v bo-ctx__trks">
                <span v-for="(t, ti) in trackings" :key="'t' + ti" class="bo-ctx__trk-item">
                    <b class="bo-ctx__trk" title="트래킹번호">{{ t }}</b>
                    <copy tooltip="트래킹번호 복사" :copy-text="t"></copy>
                </span>
                <span v-if="trackings.length === 0" class="bo-ctx__none">없음</span>
            </dd>
        </div>

        <div v-for="(it, i) in items" :key="'i' + i" class="bo-ctx__row">
            <dt class="bo-ctx__k">{{ it.k }}</dt>
            <dd class="bo-ctx__v" :class="valueClasses(it)">
                <span v-if="hasPill(it)" class="boc-pill" :class="[it.cls || '', 'state-' + it.pill]">{{ it.v }}</span>
                <template v-else>{{ it.v }}</template>
            </dd>
        </div>
    </dl>
</template>

<script>
    export default {
        props: {
            // 해외오더번호 (빈 값 = 「—」 · 복사 숨김)
            code: {
                type: String,
                required: true,
            },

            // 트래킹번호 목록 (null = 줄 숨김 · [] = 「트래킹 미입력」)
            trackings: {
                type: Array,
                default: null,
            },

            /**
             * 키-값 목록 [{k, v, big?, red?, mono?, cls?, pill?}]
             *  - big  = 큰 금액 (1.4rem 700 #1f2d4d · 줄바꿈 없음)
             *  - red  = 빨강 강조 (#c62828)
             *  - mono = 모노 글꼴
             *  - cls  = 값 요소 추가 class (공백 구분 여러 개 — E2E 셀렉터 보존)
             *  - pill = 대금상환 상태값 → .boc-pill.state-{pill} 라벨로 표시 (cls 는 라벨에 부착)
             */
            items: {
                type: Array,
                default: function () {
                    return [];
                },
            },

            // 오더번호 복사 아이콘
            copyable: {
                type: Boolean,
                default: true,
            },

            // 오더번호 값 요소 추가 class (E2E 셀렉터 보존)
            codeClass: {
                type: String,
                default: '',
            },
        },
        computed: {
            hasCode() {
                return this.code !== null && this.code !== undefined && String(this.code).trim() !== '';
            },
        },
        methods: {
            hasPill(it) {
                return it.pill !== undefined && it.pill !== null && it.pill !== '';
            },

            // 값 요소 class = 수식 (big · red · mono) + cls (pill 이면 cls 는 라벨 쪽에 부착)
            valueClasses(it) {
                let classes = [{
                    'is-big': !! it.big,
                    'is-red': !! it.red,
                    'is-mono': !! it.mono,
                }];
                if (it.cls && ! this.hasPill(it)) {
                    classes.push(it.cls);
                }
                return classes;
            },
        },
    }
</script>

<style lang="scss" scoped>
    // 쌍 (라벨 + 값) = 폭 절반 · flex-wrap — 최소폭 = 내용 (큰 금액 nowrap) 이라 절반에 안 들어가면 그 쌍만 다음 줄 전폭 (좁은 화면 = 자연 1열)
    .bo-ctx {
        position: relative; // 머리 아래 구분선 (::after) 기준
        display: flex;
        flex-wrap: wrap;
        gap: 6px 24px;
        margin: 0 0 16px;
        padding: 10px 14px;
        border-radius: 6px;
        background: #f3f5f9;
        font-size: 1rem;

        // TASK-172 결정 v2-④ — 머리 아래 구분선 (블록과 본문 사이 여백 가운데 1px, 7 모달 공통)
        &::after {
            content: "";
            position: absolute;
            right: 0;
            bottom: -9px;
            left: 0;
            border-bottom: 1px solid #c9ced6;
        }
    }

    .bo-ctx__row {
        display: flex;
        align-items: baseline;
        gap: 4px 10px;
        flex: 1 1 calc(50% - 24px);
    }

    // 오더번호 · 트래킹 = 전폭 줄 · 라벨 폭 고정 (두 줄 값 시작 x 맞춤)
    .bo-ctx__row--full {
        flex-basis: 100%;

        > .bo-ctx__k {
            flex: none;
            min-width: 6.5rem;
        }
    }

    .bo-ctx__k {
        flex: none;
        margin: 0;
        color: #6b7280;
        font-weight: 400;
        white-space: nowrap;
    }

    .bo-ctx__v {
        min-width: 0;
        margin: 0;
        color: #222;
        font-weight: 500;
        word-break: break-all;

        &.is-big {
            font-family: inherit;
            font-size: 1.4rem;
            font-weight: 700;
            font-variant-numeric: tabular-nums;
            line-height: 1.3;
            color: #1f2d4d;
            white-space: nowrap;
            word-break: normal;
        }

        &.is-mono {
            font-family: "IBM Plex Mono", ui-monospace, monospace;
        }

        &.is-red {
            color: #c62828;
        }
    }

    .bo-ctx__codeline {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 4px 8px;
    }

    .bo-ctx__code {
        font-family: "IBM Plex Mono", ui-monospace, monospace;
        font-size: 1.2rem;
        font-weight: 700;
        color: #111;
        word-break: break-all;
    }

    .bo-ctx__trks {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 4px 18px;
    }

    // 트래킹 = 금액과 동급 강조 (TASK-172 절 D — 1.4rem 700 #111 모노) + 번호마다 복사
    .bo-ctx__trk-item {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        min-width: 0;
    }

    .bo-ctx__trk {
        font-family: "IBM Plex Mono", ui-monospace, monospace;
        font-size: 1.4rem;
        font-weight: 700;
        line-height: 1.3;
        color: #111;
        word-break: break-all;
    }

    .bo-ctx__none {
        color: #a3a9b3;
        font-weight: 400;
    }
</style>
